import { gql } from "@apollo/client";

export const GET_AUTORIZACIONES_CAMBIOS_PRECIO = gql`
query GetAutorizacionesCambioPrecio($filter: AutorizacionCambioPrecioFilterInput!) {
  autorizacionesCambioPrecio(filter: $filter) {
    success,
    error,
    valorEsperado {
      idAutorizacionPrecioMasivo
      delegacion      
      fecha
      solicitante
      idEvaluacion
      paciente
      planCuidado
      codigoPlan
      financiador
      periodo
      precioActual
      precioSAP
      precioControl
      precioACambiar
      viable
      seleccionar
    }
  }
}`;